import { ExitIcon } from '@components/ExitIcon/ExitIcon';
import { VideoIcon } from '@components/Icons/VideoIcon';
import { secondsToHMS } from '@lib/utils/time';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { useUIPreferences } from '@stores/UIPreferences';
import { observer } from 'mobx-react';
import css from './ClipSearch.module.scss';

export const ClipSearch = observer(() => {
  const libraryManager = useLibraryManager();
  const librarySearch = libraryManager.multiLibSearch;
  const uiPreferences = useUIPreferences();

  if (!librarySearch.request?.clipId) return null;
  const preview = librarySearch.searchClipPreview;
  if (!preview) return null;

  return (
    <div className={css.image}>
      <img src={preview.preview} alt="query image" />
      <div className={css.overlay} />
      <ExitIcon
        onClick={() => {
          librarySearch.setSearchClip(null);
          uiPreferences.searchBarFocusCallback?.();
        }}
      />
      <div className={css.lowerLeft}>
        <span className={css.chip}>
          {secondsToHMS(preview.clip.endTime - preview.clip.startTime)}
        </span>
      </div>
      <div className={css.lowerRight}>
        <div className={css.videoIconChip}>
          <VideoIcon />
        </div>
      </div>
    </div>
  );
});
